import { render, staticRenderFns } from "./DashboardMobile.vue?vue&type=template&id=07ac16b3&scoped=true"
import script from "./DashboardMobile.vue?vue&type=script&lang=js"
export * from "./DashboardMobile.vue?vue&type=script&lang=js"
import style0 from "./DashboardMobile.vue?vue&type=style&index=0&id=07ac16b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ac16b3",
  null
  
)

export default component.exports